<template>
    <div>
        <transition name="fade" mode="out-in">
            <v-container class="px-12 py-12" fluid>
                <v-content>
                    <router-view></router-view>
                    <router-view name="classic-drawer"></router-view>
                    <router-view name="narrow-drawer"></router-view>
                </v-content>
            </v-container>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "Main"
    }
</script>

<style scoped>

</style>
